import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link as RouterLink, LinkProps } from 'react-router'
import { Link as RebassLink } from 'rebass/styled-components'

export interface LinkItem extends LinkProps {
  type: 'link'
  text?: string
  textId?: string
}

export const BreadcrumbLink = ({ text, textId, ...props }: LinkItem): JSX.Element => (
  <RebassLink data-name="BreadcrumbLink" as={RouterLink} variant="links.breadcrumb" {...props}>
    {textId ? <FormattedMessage id={textId} /> : text}
  </RebassLink>
)
